// extracted by mini-css-extract-plugin
export default {"inputWrapper":"LoginInput_inputWrapper__c7D0K","input":"LoginInput_input__80Xas"};